module.exports = __webpack_public_path__ + "statics/img/TargetAudience-1.ef8d6b06.png";